//
//
//
//
//
//
//
//
//
//
//
//
//

import Add from "@/components/RegionAccount/Add";
export default {
  name: "AddCounty",
  components: { Add },
  data() {
    return {
      accountType: "county",
    };
  },
};
